module.exports = __webpack_public_path__ + "img/Лицензия-на-меддеятельность-21.02.2018-4.aa39946e.jpg";